export const ticketsStatus = [
    {name: 'In progress', value: 40, color: '#45C3E5'},
    {name: 'On Hold', value: 8, color: '#E0E0E0'},
    {name: 'Closed', value: 15, color: '#E16618'},
    {name: 'Open', value: 58, color: '#57BE4A'},
];
